var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mapIsLoading),expression:"mapIsLoading"}],staticClass:"map-loading-div mt-1"},[_c('v-row',[_c('div',{staticClass:"caption pr-2"},[_vm._v("Laster kartdata")]),_c('v-progress-circular',{attrs:{"size":"16","indeterminate":"","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }